"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendHealthcheckPing = void 0;
const axios_1 = __importDefault(require("axios"));
const sendHealthcheckPing = async (healthcheckPingUrl) => {
    if (healthcheckPingUrl) {
        try {
            await axios_1.default.get(healthcheckPingUrl);
        }
        catch (e) {
            const error = e;
            if (error.code === "ENOTFOUND") {
                console.error("Healthcheck address not found. Configure your `HEALTHCHECK_PING_URL` properly");
            }
            else {
                console.error(`Unknown error occurred, when trying to health check ping code: ${error.code} message: ${error.message}`);
            }
        }
    }
};
exports.sendHealthcheckPing = sendHealthcheckPing;
//# sourceMappingURL=send-healthcheck-ping.js.map